import type { Participant } from "@/api/types";
import { Modal } from "./Modal";
import { Avatar } from "./Avatar";
import "./participant-picker.css";

export interface ParticipantPickerProps {
  open: boolean;
  participants: ReadonlyArray<Participant>;
  /** Currently selected participant_id (visually pre-selected in the list). */
  selectedId?: string | null;
  /** Called when the user taps a row — selection IS the confirmation. */
  onPick: (participantId: string) => void;
  onCancel: () => void;
}

/**
 * Picker for choosing who paid. Uses the existing <Modal> primitive
 * (BottomSheet is out of MVP). Selection inside the list is itself the
 * confirmation, so the modal hides its confirm button.
 */
export function ParticipantPicker({
  open,
  participants,
  selectedId,
  onPick,
  onCancel,
}: ParticipantPickerProps) {
  return (
    <Modal
      open={open}
      title="Хто платив?"
      variant="default"
      cancelLabel="Скасувати"
      hideConfirm
      onCancel={onCancel}
      // No-op confirm: hideConfirm hides the button so this is never invoked.
      onConfirm={onCancel}
    >
      <ul
        className="wp-picker__list"
        role="listbox"
        aria-label="Учасники"
        data-testid="participant-picker"
      >
        {participants.map((p) => {
          const selected = p.participant_id === selectedId;
          return (
            <li key={p.participant_id} className="wp-picker__item">
              <button
                type="button"
                className={
                  selected
                    ? "wp-picker__row wp-picker__row--selected"
                    : "wp-picker__row"
                }
                role="option"
                aria-selected={selected}
                onClick={() => onPick(p.participant_id)}
                data-testid="participant-picker-row"
              >
                <Avatar participant={p} size="sm" />
                <span className="wp-picker__name">{p.name}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </Modal>
  );
}
